import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-sentmailwithdetails',
  templateUrl: './sentmailwithdetails.component.html',
  styleUrls: ['./sentmailwithdetails.component.scss']
})
export class SentmailwithdetailsComponent implements OnInit {

  public sessionStorage = sessionStorage;
  status: boolean;
  constructor(private commonServ: CommonService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
  }

  refresh(params: ICellRendererParams): boolean {
    debugger
    throw new Error("Method not implemented.");
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }
  private params: any;

  paramsdata: any;
  agInit(params: any): void {
    console.log(params['data'])
    this.paramsdata = params['data']
    this.status = params.value;
    this.params = params;
  }
  // toggleStatusDependency(event) {
  //   console.log("x", event)
  //   this.status = event.checked;
  //   this.paramsdata['enabled_flag'] = this.status
  //   console.log('this.paramsdata', this.paramsdata)
  //   this.commonServ.updatestatus(this.paramsdata).subscribe((response) => {
  //     if (this.status) {
  //       this._snackBar.open('Status Enable Successfully', "Close", {
  //         duration: 2000,
  //         verticalPosition: 'top',
  //         horizontalPosition: 'center',
  //       });
  //     } else if (!this.status) {
  //       this._snackBar.open('Status Disable Successfully', "Close", {
  //         duration: 2000,
  //         verticalPosition: 'top',
  //         horizontalPosition: 'center',
  //       });
  //     }

  //   })
  // }

  sentmail(event: any) {
    console.log("event", this.paramsdata)

    // alert("mail sent")
    if (this.paramsdata['email_id_sent'] == "NA") {
      this._snackBar.open('There is no Email id is present for this tenant', "Close", {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
      });
    } else {
      this.commonServ.sentdetails(this.paramsdata['email_id_sent'], this.paramsdata['user_id']).subscribe((response) => {
        this._snackBar.open('Email Sent Successfully', "Close", {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
        });
      })
    }
  }

}